import { RVConfirmationTriggerModalButton } from "@regal-voice/ui";
import { JourneyStatus } from "Types/Journey";

export function SaveAsDraftButton({
    disabled,
    pendingOperation,
    handleSaveDraft,
}: {
    disabled: boolean;
    pendingOperation: string | null;
    handleSaveDraft: () => Promise<void>;
}): JSX.Element {
    return (
        <RVConfirmationTriggerModalButton
            disabled={disabled}
            loading={pendingOperation == JourneyStatus.DRAFT}
            handleMethod={handleSaveDraft}
            buttonText="Save as Draft"
            title="Save Journey as Draft?"
            content={
                <>
                    <span>
                        Saving this journey as a draft will prevent new entrances and/or delete scheduled journeys.
                    </span>
                    <br></br>
                    <br></br>
                    <span>
                        However, in-progress contacts will continue to move through the journey. To make in-progress
                        contacts exit from the journey, click &quot;Stop&quot; instead.
                    </span>
                </>
            }
            confirmText="Yes, Save as Draft"
            okLoading="Saving As Draft"
        />
    );
}
